/**
 * @param jsonValues.result
 * @param jsonValues.values
 * @param jsonValues.years
 */

// ATTENTION UI DESIGNERS
// ---------------------
// This is an Echart definition of a chart. You can explore it in the Echarts PLAYGROUND (https://echarts.apache.org/examples/en/editor.html)
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// Echarts list of examples: https://echarts.apache.org/examples/en/index.html#chart-type-pie
// An example Echart: https://echarts.apache.org/examples/en/editor.html?c=pie-doughnut
// PLAYGROUND: https://echarts.apache.org/examples/en/editor.html
// DOCUMENTATION: https://echarts.apache.org/en/option.html
// NOTE: Always verify that this file works in both Connect and the PLAYGROUND
// NOTE: Developer, when possible, update the `option = options({ ... put example values here if possible ... })` to reflect example data.
// This entire file can be cut and pasted into the PLAYGROUND IF you change the commenting on the following 2 lines

import * as echarts from "echarts/core";

// In the PLAYGROUND, comment out this line. In this file, keep it uncommented.
export { options };
// In the PLAYGROUND, uncomment this line and add/change values. In this file, keep it commented.
// option = options({value: 33, max: 100, percentile: 18, percentileText: "testing 123" });


function options(jsonValues) {
  // VARIABLES BEGIN: all variables pulled in from the jsonValues should be listed here
  const values = jsonValues.values;
  const result = jsonValues.result;
  const years = jsonValues.years;
  const dataPointColors = jsonValues.dataPointColors;

  const getHexFromToken = (token) => getComputedStyle(document.body).getPropertyValue(token)
  const getTokenFromFlagInt = (flagInt) => {
    return {
      "0": "--green-600",
      "10": "--gray-500",
      "20": "--warning-500",
      "30": "--red-600",
      "40": "--blue-500",
      "50": "--blue-400"
    }[flagInt] || "--gray-500";
  }
  const getHexFromFlagInt = (colorValue) => getHexFromToken(getTokenFromFlagInt(colorValue));


  let colorHex = [
    { offset: 0, color: getHexFromFlagInt(result) },
    { offset: 1, color: getHexFromToken("--white") },
  ];
  let lineColor = getHexFromFlagInt(result);

  // VARIABLES END

  return {
    tooltip: {
      formatter: function (params) {
        let colorSpan = (color) =>
          '<span style="display:inline-block;margin-right:10px;border-radius:10px;width:9px;height:9px;background-color:' +
          color +
          '"></span>';
        let tooltip;
        params.forEach((item) => {
          let dataPoint = colorSpan(getHexFromFlagInt(dataPointColors[item.dataIndex])) + item.data;
          tooltip = params[0].axisValue + "<br>" + dataPoint;
        });
        return tooltip;
      },
      trigger: "axis",
      axisPointer: {
        type: "line",
        label: {
          backgroundColor: getHexFromToken("--gray-400"),
        },
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: years,
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 100,
      tickInterval: 20,
    },
    series: [
      {
        data: values,
        type: "line",
        smooth: true,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, colorHex),
        },
        lineStyle: {
          color: lineColor,
        },
        itemStyle: {
          color: lineColor,
        },
        showSymbol: years.length === 1,
      },
    ],
  };
}
